import * as React from "react"
import { useState } from "react"
import styled from "styled-components"
import { ChevronDownIcon } from "../../icons/ChevronDown"

const AccordionContainer = styled.div`
  border: ${({ theme }) => `1px solid ${theme.colors.grey.$200}`};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
`

const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

const AccordionTitle = styled.div`
  margin: 0;
  flex: 1;
  display: flex;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
  user-select: none;
  align-items: center;
`

const AccordionContent = styled.div<{ $isOpen?: boolean }>`
  margin-left: 2rem;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  transition: max-height 0.2s ease-in-out;
  max-height: ${({ $isOpen }) => ($isOpen ? "1000px" : "0")};
  overflow: scroll;
`

const ChevronContainer = styled.div`
  margin-right: 0.5rem;
`

const ChevronUpIcon = styled(ChevronDownIcon)<{
  $isOpen?: boolean
}>`
  width: 1.5rem;
  height: 1.5rem;
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease-in-out;
`

interface AccordionProps {
  title: React.ReactNode
  children: React.ReactNode
  onlyChevron?: boolean
  isDefaultOpen?: boolean
  chevronPosition?: "left" | "right"
}

export const DeprecatedAccordion: React.FC<AccordionProps> = ({
  title,
  children,
  isDefaultOpen = false,
  onlyChevron = false,
  chevronPosition = "left",
}) => {
  const [isOpen, setIsOpen] = useState(isDefaultOpen)

  const toggleAccordion = () => {
    if (!onlyChevron) {
      setIsOpen(!isOpen)
    }
  }

  return (
    <AccordionContainer className="hero-accordion">
      <AccordionHeader className="hero-accordion-header" onClick={toggleAccordion}>
        {chevronPosition === "left" && (
          <ChevronContainer className="hero-accordion-chevron-container">
            <ChevronUpIcon $isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
          </ChevronContainer>
        )}
        <AccordionTitle className="hero-accordion-title">{title}</AccordionTitle>
        {chevronPosition === "right" && (
          <ChevronContainer className="hero-accordion-chevron-container">
            <ChevronUpIcon $isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
          </ChevronContainer>
        )}
      </AccordionHeader>
      <AccordionContent className="hero-accordion-content" $isOpen={isOpen}>
        {children}
      </AccordionContent>
    </AccordionContainer>
  )
}
